import { Provider } from "mobx-react";
import React, { Component } from "react";

import { isTouchDevice } from "../@helpers";
import Chatbot from "../components/Chatbot";
import CookieNotification from "../components/CookieNotification";
import SiteFooter from "../components/SiteFooter";
import SiteHeader from "../components/SiteHeader";
import stores from "../@stores";

import "../scss/index.scss";

export default class extends Component {
  state = {
    classes: []
  };

  componentDidMount() {
    let browser = "";

    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) !== -1
    ) {
      browser = "opera";
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
      browser = "chrome";
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
      browser = "safari";
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
      browser = "firefox";
    } else if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      !!document.documentMode === true
    ) {
      //IF IE > 10
      browser = "ie";
    } else {
      browser = "unknown";
    }

    var touch = [isTouchDevice() ? "is-touch" : "not-touch"];

    this.setState({ classes: "browser-" + browser + " " + touch });
  }

  render() {
    const { children } = this.props;
    return (
      <Provider {...stores}>
        <div className={`page ${this.state.classes} ${process.env.REACT_APP_LANG === 'ar-ar' ? 'rtl' : ''}`}>
          <SiteHeader />
          <main>{children}</main>
          <SiteFooter />
          <CookieNotification />
          {process.env.REACT_APP_LANG !== 'ar-ar' && <Chatbot />}
        </div>
      </Provider>
    );
  }
}
